getExperiment = require 'app/scripts/lib/experiments/simple-test'
t = require('app/scripts/views/internal/teacup-with-helpers')('filter_cards_search_results')

module.exports = ->
  t.mustacheBlock 'showHelper', ->
    t.p '.quiet', { style: 'padding: 10px 8px 2px; margin-bottom: 0;' }, ->
      t.format 'type-to-search-by-term-label-member-or-due-time'

  t.mustacheBlock 'showLabels', ->
    t.hr()

    t.ul { class: 'label-list' + t.mustacheBlock('limitLabels', (-> ' limited')) }, ->

      t.mustacheBlock 'labels', ->
        t.li { class: 'label-list-item' + t.mustacheBlock('isActive', (-> ' is-active')) }, ->
          t.a '.label-list-item-link.js-toggle-label-filter', { href: '#', 'data-name': t.mustacheVar('color'), 'data-idlabel': t.mustacheVar('id') }, ->
            t.div '.label-list-item-link-label', ->
              t.span { class: 'card-label mod-square card-label-' + t.mustacheVar('color') }
            t.mustacheBlock 'name', ->
              t.span '.label-list-item-link-name', ->
                t.text t.mustacheVar('name')
            t.mustacheBlockInverted 'name', ->
              t.span '.label-list-item-link-name.mod-quiet', ->
                t.format 'color-label-default', { color: t.mustacheVar('defaultColorName') }
            t.icon 'check', { class: 'label-list-item-link-icon' }

      t.mustacheBlock 'limitLabels', ->
        t.li '.label-list-item.js-show-all-labels-elem', ->
          t.a '.label-list-item-link.js-show-all-labels', { href: '#' }, ->
            t.span '.label-list-item-link-name.mod-quiet', ->
              t.format 'show-all-labels-remaininglabels-hidden', { remainingLabels: t.mustacheVar('remainingLabels') }

  t.mustacheBlock 'showMembers', ->
    t.hr()

    t.ul { class: 'pop-over-member-list checkable js-mem-list' + t.mustacheBlock('limitMembers', (-> ' limited')) }, ->

      t.mustacheBlock 'members', ->
        t.mustachePartial 'select_member'

    t.mustacheBlock 'limitMembers', ->
      t.ul '.pop-over-member-list', ->
        t.li '.item', ->
          t.a '.name.quiet.js-show-all-members', { href: '#', style: 'padding-left: 42px; font-weight: normal; margin-top: 4px;' }, ->
            t.format 'show-all-members-remainingmembers-hidden', { remainingMembers: t.mustacheVar('remainingMembers') }

  t.mustacheBlock 'showDueTimes', ->
    t.hr()

    t.ul '.pop-over-list.checkable.navigable.inset.normal-weight', ->

      t.mustacheBlock 'dueOptions', ->
        t.li { class: 'item ' + t.mustacheBlock('isActive', (-> ' active')) }, ->
          t.a '.js-due-filter', { href: '#', time: t.mustacheVar('time'), style: 'padding-left: 40px;' }, ->
            t.text t.mustacheVar('desc')
            t.icon 'check'

  t.mustacheBlock 'showMatchMode', ->
    t.hr()

    t.ul '.pop-over-list.checkable.navigable.inset.normal-weight', ->
      t.mustacheBlock 'modes', ->
        t.li { class: 'item ' + t.mustacheBlock('isActive', (-> ' active')) }, ->
          t.a '.js-mode-filter', { href: '#', mode: t.mustacheVar('mode'), style: 'padding-left: 40px;' }, ->
            t.text t.mustacheVar('desc')
            t.icon 'check'

  t.hr()

  t.ul '.pop-over-list.inset.normal-weight', ->

    t.li ->
      t.a { href: '#', class: 'js-clear-all' + t.mustacheBlockInverted('isFiltering', (-> ' disabled')), style: 'padding-left: 40px;' }, ->
        t.format 'clear-search'
